import { FieldDefinition } from '../../../components/data-importer/fields/FieldDefinitions';
import { Project } from '../../../domain/project/Project';

export const getTaskFields = (project: Project) => {
  const clientFields: FieldDefinition[] = [
    {
      id: `external_id`,
      type: `text`,
    },
    {
      id: `label`,
      type: `text`,
    },
  ];

  const enabledCustomFields = project.planner.taskCustomFields();

  const customFields = (project.custom_fields?.task ?? []).filter((field) => {
    return enabledCustomFields.find((enabledField) => enabledField.id === field.custom_id);
  });

  if (project.planner.taskFieldsHasSpecificField(`barcode`)) {
    clientFields.push({
      id: `barcode`,
      type: `text`,
    });
  }
  if (project.planner.taskFieldsHasSpecificField(`comments`)) {
    clientFields.push({
      id: `comments`,
      type: `text`,
    });
  }

  customFields.forEach((field) => {
    if (project.planner.taskHasCustomField(field.custom_id)) {
      if (field.field_type === `categorical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          options: field.options as string[],
          isMultipleChoice: field.multiple || false,
          isCustomField: true,
        });
      } else if (field.field_type === `numerical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `text`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `boolean`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      }
    }
  });

  return clientFields;
};
